export default {"src":"/_next/static/media/safetydog.5cec9575.svg","height":99,"width":295,"blurWidth":0,"blurHeight":0};